import { FC } from 'react';
import useRedirect from 'src/hooks/useRedirect';

interface CancelDocument {
  linkedDocumentId?: string | null;
  documentType?: string;
  poId: string;
}
export const CancelSelectedDocumentInternalContent: FC<CancelDocument> = ({
  linkedDocumentId,
  documentType,
  poId,
}) => {
  const { getUrl, redirect } = useRedirect();
  const handleClick = () => {
    if (documentType === 'Invoice')
      redirect(getUrl('receiptDetails')(linkedDocumentId as string, poId));
  };

  return (
    <div>
      <p>
        Cancelled documents cannot be re-instated, are read-only, and are ignored by system reports
        and variance calculations.
      </p>
      <p>Attachment(s) will be unattached and returned to queue for reassignment.</p>
      {linkedDocumentId && (
        <p className="mt-3">
          The linked document{' '}
          <span className="text-link cursor-pointer underline" onClick={handleClick}>
            #{linkedDocumentId}
          </span>{' '}
          will be unlinked but not cancelled.
        </p>
      )}
      <p className="mt-3"> Are you sure you wish to cancel the selected document(s)? </p>
    </div>
  );
};
